import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authApi } from "./apis/AuthApi";
import { GoogleMapApi } from "./apis/google-map";
import { internalApi } from "./apis/internal-api";
import { losApi } from "./apis/los-api";
import { utmApi } from "./apis/los-api/utmApi";
import { paytmApi } from "./apis/paytm-api";
import { offerSelectionSlice } from "./slice";
import { afSlice } from "./slice/AppsFlyerSlice";
import { insuranceSlice } from "./slice/InsuranceSlice";
import { modalSlice } from "./slice/ModalSlice";
import { applicationSlice } from "./slice/ApplicationSlice";
import { mapplsApi } from "./apis/map-my-india";
import { creditScoreApi } from "./apis/credit-score";

const RESET_STORE = 'RESET_STORE';

const appReducer = combineReducers({
    [afSlice.name]: afSlice.reducer,
    [losApi.reducerPath]: losApi.reducer,
    [utmApi.reducerPath]: utmApi.reducer,
    [modalSlice.name]: modalSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [paytmApi.reducerPath]: paytmApi.reducer,
    [internalApi.reducerPath]: internalApi.reducer,
    [GoogleMapApi.reducerPath]: GoogleMapApi.reducer,
    [offerSelectionSlice.name]: offerSelectionSlice.reducer,
    [insuranceSlice.name]: insuranceSlice.reducer,
    [applicationSlice.name]: applicationSlice.reducer,
    [mapplsApi.reducerPath]: mapplsApi.reducer,
    [creditScoreApi.reducerPath]: creditScoreApi.reducer,
  });


const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  devTools: { 
    trace: process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production',
    traceLimit: 25
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(
      losApi.middleware,
      utmApi.middleware,
      authApi.middleware,
      paytmApi.middleware,
      internalApi.middleware,
      GoogleMapApi.middleware,
      mapplsApi.middleware,
      creditScoreApi.middleware,
    );
  },
});
setupListeners(store.dispatch);

// Export all the hooks and actions from the API
export * from "./apis/AuthApi";
export { useGetMapAddressQuery } from "./apis/google-map";
export * from "./apis/internal-api";
export * from "./apis/los-api";
export { useInitiatePaymentMutation } from "./apis/paytm-api";
export * from "./slice";
export * from "./apis/credit-score";
export const resetStore = () => ({ type: RESET_STORE });
